export default "__VITE_ASSET__Dwev71cW__"